export const blockIconsMapsLocalLibrary = (
	<span className='material-symbols-outlined'>local_library</span>
);
